module.exports = __webpack_public_path__ + "static/media/Logout.16fd31bd.svg";